import { connect } from 'react-redux'
import { getSelectedCollaborativeIndexationsFields } from '../../../../redux/collaborativeIndexations/selectors'
import CollaborativeIndexations from './CollaborativeIndexations.jsx'
import {
    closeAndUnselectCollaborativeIndexationSummary,
} from '../../../../redux/collaborativeIndexations/actions'

const mapStateToProps = state => ({
    fields: getSelectedCollaborativeIndexationsFields(state),
})

const mapDispatchToProps = (dispatch, getState) => ({
    close: () => {
        dispatch(closeAndUnselectCollaborativeIndexationSummary())
    }
})

export const CollaborativeIndexationsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CollaborativeIndexations)
